const showRadius = (radius) => (radius < 36 ? `${radius}px` : "35px");
export default showRadius;